import React from 'react'
import useSteps from '../../hooks/useSteps'

export default function IsStep ({ step, children }) {

  const { currentStepIndex } = useSteps()

  if (step !== currentStepIndex) {
    return null
  }

  return children
}
